import { createSlice } from "@reduxjs/toolkit";
import { updateEnrollmentAgreementAPI } from "../../services/updateEnrollmentAgreement";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const updateEnrollmentAgreementSlice = createSlice({
  name: "updateEnrollmentAgreement",
  initialState,
  reducers: {
    updateEnrollmentAgreementInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
      state.statusCode = undefined;
    },
    updateEnrollmentAgreementInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "Enrollment Agreement saved successfully";
      state.error = "";
      state.statusCode = undefined;
    },
    updateEnrollmentAgreementInfoFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = "";
      state.error = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    updateEnrollmentAgreementInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const updateEnrollmentAgreementHandler =
  (payload, options = {}) =>
  async (dispatch) => {
    const requestOptions = { skipForbiddenRedirect: true, ...options };

    try {
      dispatch(
        updateEnrollmentAgreementAction.updateEnrollmentAgreementInfo(payload),
      );
      const response = await updateEnrollmentAgreementAPI(
        payload,
        requestOptions,
      );
      dispatch(
        updateEnrollmentAgreementAction.updateEnrollmentAgreementInfoSuccess(
          response,
        ),
      );
    } catch (e) {
      const failurePayload =
        e && typeof e === "object" && "message" in e
          ? e
          : { message: e || "Something went wrong." };
      dispatch(
        updateEnrollmentAgreementAction.updateEnrollmentAgreementInfoFailure(
          failurePayload,
        ),
      );
    }
  };

export default updateEnrollmentAgreementSlice.reducer;
export const updateEnrollmentAgreementAction =
  updateEnrollmentAgreementSlice.actions;
